module.exports = __webpack_public_path__ + "static/media/shoes.d3245d55.png";